import {twMerge} from '../../common/twMerge';
import {Dot} from '../atoms/Dot/Dot';
import {Icon} from '../atoms/Icon/Icon';
import {IconWithDotProps} from './IconWithDot/IconWithDotProps.interface';

export function IconWithDot({
  isShowDot,
  iconType,
  className,
  ariaHidden = true,
  ...props
}: IconWithDotProps) {
  return (
    <div className={twMerge('relative cursor-pointer', className)} {...props}>
      <Icon type={iconType} ariaHidden={ariaHidden} />
      {isShowDot && <Dot className="absolute top-0 -right-4pxr" />}
    </div>
  );
}
